import React from "react";
import styles from "./Input.module.css";

export default props => (
  <input {...props} className={`${styles.input} ${props.className}`} />
);
